var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideMessage)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"ui red small pointing label"},[_vm._v(_vm._s(_vm.message))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }